/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetReservationCancellation200Response,
  GetReservationWarranty200Response,
} from '../models/index';
import {
    GetReservationCancellation200ResponseFromJSON,
    GetReservationCancellation200ResponseToJSON,
    GetReservationWarranty200ResponseFromJSON,
    GetReservationWarranty200ResponseToJSON,
} from '../models/index';

export interface UpsertReservationCancellationRequest {
    getReservationCancellation200Response: GetReservationCancellation200Response;
}

export interface UpsertReservationWarrantyRequest {
    getReservationWarranty200Response: GetReservationWarranty200Response;
}

/**
 * 
 */
export class PoliciesApi extends runtime.BaseAPI {

    /**
     */
    async getReservationCancellationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationCancellation200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/policies/cancellation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationCancellation200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationCancellation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationCancellation200Response> {
        const response = await this.getReservationCancellationRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationWarrantyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationWarranty200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/policies/warranties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationWarranty200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationWarranty(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationWarranty200Response> {
        const response = await this.getReservationWarrantyRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertReservationCancellationRaw(requestParameters: UpsertReservationCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationCancellation200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationCancellation200Response',
                'Required parameter "getReservationCancellation200Response" was null or undefined when calling upsertReservationCancellation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/policies/cancellation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationCancellation200ResponseToJSON(requestParameters['getReservationCancellation200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationCancellation(requestParameters: UpsertReservationCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationCancellationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationWarrantyRaw(requestParameters: UpsertReservationWarrantyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationWarranty200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationWarranty200Response',
                'Required parameter "getReservationWarranty200Response" was null or undefined when calling upsertReservationWarranty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/policies/warranties`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationWarranty200ResponseToJSON(requestParameters['getReservationWarranty200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationWarranty(requestParameters: UpsertReservationWarrantyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationWarrantyRaw(requestParameters, initOverrides);
    }

}
